import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const cookies = uni.getStorageSync('cookies');
const userInfo = uni.getStorageSync('userInfo');

const store = new Vuex.Store({
	
	state: {
		cookies: cookies || '',
		userInfo: userInfo || null
	},
	
	mutations: {
		// 设置cookies
		setCookies(state, val) {
			state.cookies = val
			uni.setStorageSync('cookies', val);
		},
		// 设置用户信息
		setUserInfo(state, val) {
			state.userInfo = val
			uni.setStorageSync('userInfo', val);
		},
		// 清空缓存
		empty(state) {
			state.cookies = ''
			state.userInfo = null
			uni.clearStorage()
		}
	}
	
})

export default store;